module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}} ({{currentScenario.id}})</strong></div>\r\n\r\n<div class=\"panel-body\">\r\n    <h4>Reforecast done for scenario {{reforecastScenarioName}}</h4>\r\n\r\n    <div class=\"divider\">&nbsp;</div>\r\n\r\n    <div>Please go back to <a [routerLink]=\"['/scenario-reforecast']\">Reforecast</a></div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/scenario-activities/scenario-reforecast-complete.component.html
 ** module id = 889
 ** module chunks = 0
 **/